import { render, staticRenderFns } from "./DinamicFields.vue?vue&type=template&id=f47341c2&"
import script from "./DinamicFields.vue?vue&type=script&lang=js&"
export * from "./DinamicFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports